module.exports = __webpack_public_path__ + "static/media/plantillas.993ad87a.svg";